module.exports = __webpack_public_path__ + "static/img/join_3.b782a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/join_3.jpg
// module id = RhVA
// module chunks = 0